/**
 * Helpers for displaying client intake submissions in VIVA HUB
 */

export const INTAKE_SERVICE_LABELS = {
  individual_counseling: 'Individual counseling',
  family_couples: 'Family / Couples counseling',
  support_group: 'Support group',
  professional_consultation: 'Professional consultation',
}

export const INTAKE_CLIENT_TYPE_LABELS = {
  adult: 'Adult',
  minor: 'Minor',
  couple: 'Couple',
}

export function getIntakePrimaryLabel(submission) {
  const { client_type, form_data: data } = submission
  if (client_type === 'adult' && data.adult) {
    return `${data.adult.first_name} ${data.adult.last_name}`.trim()
  }
  if (client_type === 'minor' && data.minor) {
    return data.minor.minor_full_name || data.minor.guardian_name
  }
  if (client_type === 'couple' && data.person1) {
    return `${data.person1.first_name} ${data.person1.last_name}`.trim()
  }
  return '—'
}

export function getIntakePrimaryEmail(submission) {
  const { client_type, form_data: data } = submission
  if (client_type === 'adult' && data.adult) return data.adult.email
  if (client_type === 'minor' && data.minor) return data.minor.guardian_email
  if (client_type === 'couple' && data.person1) return data.person1.email
  return ''
}

/** Flat list of { label, value } for detail panel with copy buttons */
export function flattenIntakeFields(submission) {
  const { client_type, form_data: data, service_type } = submission
  const fields = [
    { label: 'Client type', value: INTAKE_CLIENT_TYPE_LABELS[client_type] || client_type },
    {
      label: 'Service',
      value: INTAKE_SERVICE_LABELS[service_type] || service_type,
    },
  ]

  if (client_type === 'adult' && data.adult) {
    const p = data.adult
    fields.push(
      { label: 'First name', value: p.first_name },
      { label: 'Last name', value: p.last_name },
      { label: 'Date of birth', value: p.dob },
      { label: 'Email', value: p.email },
      { label: 'Phone', value: p.phone }
    )
  } else if (client_type === 'minor' && data.minor) {
    const m = data.minor
    fields.push(
      { label: 'Guardian name', value: m.guardian_name },
      { label: 'Guardian phone', value: m.guardian_phone },
      { label: 'Guardian email', value: m.guardian_email },
      { label: 'Minor full name', value: m.minor_full_name },
      { label: 'Minor date of birth', value: m.minor_dob }
    )
  } else if (client_type === 'couple') {
    for (const [prefix, person] of [
      ['Person 1', data.person1],
      ['Person 2', data.person2],
    ]) {
      if (!person) continue
      fields.push(
        { label: `${prefix} — First name`, value: person.first_name },
        { label: `${prefix} — Last name`, value: person.last_name },
        { label: `${prefix} — Date of birth`, value: person.dob },
        { label: `${prefix} — Email`, value: person.email },
        { label: `${prefix} — Phone`, value: person.phone }
      )
    }
  }

  return fields
}
